<template>
  <Chart :options="options" :init-options="{ renderer: 'canvas' }" autoresize v-if="pieData && pieData.length > 0"/>
</template>
<script>
import { Pie } from 'kw-bweb-chart-pc'
import Chart from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/graphic'

export default {
  data() {
    return {
      options: {}
    }
  },
  props: {
    pieData: {
      type: Array,
      default: () => [{value: 0.8,name:'abc'}, {value:0.2,name:'cdf'}]
    },
    title: {
      type: String,
      default: ''
    },
    subtext: {
      type: [String, Number],
      default: '0'
    },
    text: {
      type: [String, Number],
      default: '(占比0%)'
    },
    color: {
      type: Array,
      default: () => ['#7ED321', '#59A7FF', '#FF4C18', '#FFB000', '#A947FF']
    },
    showLegend: {
      type: Boolean,
      default: true
    }
  },
  created(){
    this.getOptions()
  },
  methods: {
    getOptions () {
      const op = Pie.getOptions({
        title: this.title,
        subtext: this.subtext,
        // textPercent: this.text,
        yData: this.pieData,
        color: this.color,
        radius: [70, 90],
        legend: {
          show: this.showLegend
        },
        titleTop: '35%',
        titleSize: 18,
        textTop: '62%',
        graphicStyle: {
          text: this.text,
          fill: '#666',
          fontSize: 14,
          fontWeight: 400
        },
        subtextStyle: {
          color: this.color[0],
          fontWeight: 700,
          fontSize: 24,
          // lineHeight: 30,
        }
      })
      // console.log(op)
      this.options = op
    }
  },
  components: {
    Chart
  }
}
</script>
<style lang="scss" scoped>

</style>
